import { render, staticRenderFns } from "./GameComment.vue?vue&type=template&id=113449e7&scoped=true"
import script from "./GameComment.vue?vue&type=script&lang=ts"
export * from "./GameComment.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./GameComment.vue?vue&type=style&index=0&id=113449e7&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "113449e7",
  "16bd8f5a"
  
)

export default component.exports